import React from 'react'
import { connect } from 'react-redux'
import { LocalForm, Control, actions } from 'react-redux-form'
import Errors from './Errors'

import {
  update_user,
  accounts_autocomplete,
  accounts_autocomplete_reset
 } from '../actions'

const { FormSelect, Autocomplete, toast, updateTextFields } = window.M

const mapStateToProps = state => {
  return {
    // form: state.forms.user,
    account_data: state.account.account_data,
    account_names: state.account.account_names,
    query: state.account.query,
    errors: state.user.errors
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateUser: (user_id, values) => dispatch( update_user(user_id, values) ),
    getAutocompleteOptions: (query) => dispatch( accounts_autocomplete(query) ),
    resetAutocomplete: () => dispatch( accounts_autocomplete_reset( ) ),
  }
}

class ConnectedUserRowEdit extends React.Component {
  constructor() {
    super()
    this.state={
      selector: null,
      autocomplete: null
    }
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  formInit() {
    const { selector } = this.state
    const { user, current_user, resetAutocomplete } = this.props
    const { id } = user

    if ( selector !== null ) {
      selector.destroy()
    }

    resetAutocomplete()

    if (current_user.id !== id) {
      setTimeout(function(self){
        const el = document.getElementById(`userrole_${id}`)
        const newSelector = FormSelect.init(el)
        self.setState({selector: newSelector})
      }, 100, this)
    }
  }

  cancel() {
    this.formDispatch(actions.reset('localUser'));
    this.props.cancel()

    setTimeout(function(){
      updateTextFields()
    }, 150)
  }

  componentDidMount() {
    const {id} = this.props.user
    this.formInit()
    setTimeout(function(self){
      const el = document.getElementById(`useraccount_${id}`)
      const autocomplete = Autocomplete.init(el, {
        data: {},
        limit: 5,
        onAutocomplete: function(value) {
          self.formDispatch(actions.change('localUser.account_name', value))
        }
      })
      self.setState({autocomplete: autocomplete})
    },100,this)
  }

  changeOptions(e) {
    const newValue = e.target.value
    if ( newValue === null) {
      return
    }
    const value = newValue.trim()
    const { searchValue } = this.state
    const { account_names } = this.props
    const total_accounts = Object.keys(account_names).length
    if ( searchValue === '' || (value.includes(searchValue) && total_accounts === 20) || (!value.includes(searchValue)) ) {
      this.props.getAutocompleteOptions(value)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { showForm, user, account_names, query } = this.props
    const previousShowForm = prevProps.showForm
    const previousUser = prevProps.user
    const previousQuery = prevProps.query

    if ( showForm !== previousShowForm && showForm === "") {
      return this.formInit()
    }

    if (JSON.stringify(previousUser) !== JSON.stringify(user)) {
      toast({
        html: "User data updated",
        displayLength: 1000,
        inDuration: 0
      })
      return this.cancel()
    }

    if ( previousQuery !== query && showForm === "") {
      console.log("QUERY " + query)
      const {autocomplete} = this.state
      return autocomplete.updateData(account_names)
    }
  }

  handleSubmit(values) {
    const {account_name, name, email, role} = values
    const {account_data, current_user, user} = this.props
    let newRole, newAccountId
    if ( (current_user.role === "manager" && role === "admin") || user.id === current_user.id ) {
      newRole = user.role
    } else {
      newRole = role
    }
    if (current_user.role === "manager") {
      newAccountId = user.account.id
    } else {
      newAccountId = account_data[account_name]
    }
    const newValues = {
      name: name,
      email: email,
      role: newRole,
      account_id: newAccountId
    }
    this.props.updateUser(user.id, newValues)

  }

  render() {
    const {showForm, user, current_user, errors} = this.props;

    if (showForm === "hide") {
      return ''
    }
    
    const rowClass = "inlineForm " + showForm.replace('hide','hidden')

    const adminOption = (current_user.role === "admin" && user.id !== current_user.id) ?
      (<option value="admin">Administrator</option>) : ""

    const {name, email, role, account} = user
    const account_name = account.name

    const showErrors = (showForm === "") ? errors : []

    return (
        <tr className={rowClass}>

            <td colSpan={5}>
              <div>
                <LocalForm
                model="localUser"
                getDispatch={(dispatch) => this.attachDispatch(dispatch)}
                onSubmit = { (values) => {
                  this.handleSubmit(values)
                }}
                initialState={{
                  name: name,
                  email: email,
                  role: role,
                  account_name: account_name
                }}
                >
                  <div className="row inlineRow">
                    <div className="col xl10 l10 s12 row">
                      <div className="input-field col s12 l3 xl3 ">
                        <label className="active" htmlFor={`username_${user.id}`} >User name</label>
                        <Control.text id={`username_${user.id}`} model= ".name" />
                      </div>

                      <div className="input-field col s12 l3 xl3">
                        <label className="active" htmlFor={`useremail_${user.id}`} >User email</label>
                        <Control.text type="email" id={`useremail_${user.id}`} model= ".email"/>
                      </div>
                      {
                        (current_user.id !== user.id) && (
                          <div className="input-field col s12 l3 xl3">
                            <label className="active" htmlFor={`userrole_${user.id}`}>Role</label>
                            <Control.select id={`userrole_${user.id}`} className="roleSelect" model=".role" defaultValue={role} onChange={(e) => {
                              e.preventDefault()
                            }}>
                              <option value="user">User</option>
                              <option value="manager">Manager</option>
                              { adminOption }
                            </Control.select>
                          </div>
                        )
                      }
                      {
                        (current_user.role === "admin") && (
                          <div className="input-field col s12 l3 xl3">
                            <label className="active" htmlFor={`useraccount_${user.id}`}>Account (autocomplete)</label>
                            <Control.text id={`useraccount_${user.id}`} model=".account_name" onChange={e=>{
                              this.changeOptions(e)
                            }}/>
                          </div>
                        )
                      }

                    </div>
                    <div className="col xl2 l2 s12 formButtons">
                      <button className="btn-small btn-flat" title="Save"><i className="material-icons tiny c-light-green">save</i></button>
                      <a href='' className="btn-small btn-flat hover-red" title="Cancel" onClick={ e=> {
                        e.preventDefault()
                        this.cancel()
                      }}><i className="material-icons tiny c-red darken-1">cancel</i></a>
                    </div>
                  </div>

                </LocalForm>

              </div>
              <Errors errors={showErrors}/>
            </td>

        </tr>

    )
  }

}

const UserRowEdit = connect(mapStateToProps, mapDispatchToProps)(ConnectedUserRowEdit)

export default UserRowEdit



// WEBPACK FOOTER //
// ./src/js/components/UserRowEdit.js